<div class="[perspective:1000px] group">
  <div class="relative w-full aspect-[16/10] rounded-2xl text-white shadow-2xl shadow-blue-500/30 transition-transform duration-500 [transform-style:preserve-3d] group-hover:[transform:rotateY(180deg)]">
    
    <!-- Front -->
    <div class="absolute inset-0 p-8 flex flex-col justify-between rounded-2xl [backface-visibility:hidden]" [style]="cardStyle()">
      <div class="flex justify-between items-start">
        <div>
            <p class="text-sm opacity-70 [text-shadow:_0_1px_1px_rgb(0_0_0_/_20%)]">Current Balance</p>
            <p class="text-3xl font-semibold tracking-tight [text-shadow:_0_1px_1px_rgb(0_0_0_/_20%)]">${{ balance() }}</p>
        </div>
        @if (cardType() === 'visa') {
          <svg class="w-16 h-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 476.1"><path d="M592.5 476.1L405.3 0h113.4l186.9 476.1H592.5zM1500 242.4c0-108.3-132.3-157.5-238.2-157.5-84.3 0-143.4 39-143.4 92.1 0 33 24 57.3 66.3 75.3l42 18c39.6 17.7 52.8 33.6 52.8 54.9 0 32.7-42.6 46.2-79.5 46.2-56.4 0-84-12-111.6-30.3l-19.8-10.2-22.5 99.3c27.6 15.3 84.6 32.7 141.9 33 138.9 0 228-54.6 228-160.8V242.4zM1114.2 476.1h112.5V0H1114.2v476.1zM937.2 476.1l-123-476.1h129.9l43.2 249c5.1 28.8 9.3 54.3 14.1 89.1h1.2c4.2-34.8 8.4-60.3 13.5-89.1l43.2-249h123.6l-123 476.1H937.2zM0 476.1h129.3L316.2 0H192.3L117 288.6h-1.2L42.9 0H0v476.1z" fill="#fff"/></svg>
        }
      </div>
       <div class="relative pt-1">
          <div class="flex mb-2 items-center justify-between text-xs">
              <div class="opacity-70 [text-shadow:_0_1px_1px_rgb(0_0_0_/_20%)]">
                  <span>${{ balance() }}</span>
              </div>
              <div class="text-right opacity-70 [text-shadow:_0_1px_1px_rgb(0_0_0_/_20%)]">
                  <span>Limit: ${{ creditLimit() }}</span>
              </div>
          </div>
          <div class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-white/20">
              <div [style.width.%]="balanceProgress()" class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-white"></div>
          </div>
      </div>
      <div class="flex justify-between items-end">
        <div class="space-y-1">
            <p class="text-xl font-mono tracking-wider [text-shadow:_0_1px_1px_rgb(0_0_0_/_20%)]">{{ formattedCardNumber() }}</p>
            <div class="flex justify-between text-sm uppercase opacity-70 [text-shadow:_0_1px_1px_rgb(0_0_0_/_20%)]">
            <span>{{ cardHolder() }}</span>
            <span>{{ expiryDate() }}</span>
            </div>
        </div>
        <img class="w-12 h-auto" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJTSURBVHgB7drtUcMwEIXh5hAJAiRAAkSACBABIkAEiAARIAJEgAgQASLg7+x5e23N2q6ds/am13S/rtZ60jT9m81m/l3X/Zmm6S/j54f/ZyF+n+3w4eZ/5AACCKSztL/MQogggEBK+sO8iSiCAB5IfzAvIcogABCSf5iXEMUQQACLlPzDvIQohgACeOT5gXkJQQwBBDDJ8wPzEpKYAgggkeUvM5eQxBBAYCPLX2YuIYkhgMCmlL/MXEISMQggkPTv5y4hiSGAQJv07+cuIYkhgECbtH85dQhJDAEEatK+nHqEJIYAArVp385dQhJDAIGaNHc5dYhIDAGKNG/nLiGJIYBBTdrc5dQhJDEEKNK8nbuEJIYABjVps5eTQ0hiCFCkeT93CUkMAQxq0uYvJ4eQxBCgSPErd4mJDAEKNGlnLxOHkMQQoEjxb+4SEhgCFGjSxi8nh5DEEKBI8e/uEpIYAhRo0uYvJ4eQxBCgSPErd4mJDAEKNGlnLxOHkMQQoEjxb+4SEhgCFGjS5i8nh5DEEKBI8U/uEpIYAhRo0uYvJ4eQxBCgSPErd4mJDAEKNGlnLxOHkMQQoEjxb+4SEhgCFGjS5i8nh5DEEKBI8U/uEpIYAhRo0uYvJ4eQxBCgSPErd4mJDAEKNGlnLxOHkMQQoEjxb+4SEhgCFGjS5i8nh5DEEKBI8e/uEpIYAhRo0uYvJ4eQxBCgSPEv7hISKQIoaNLmLyeHkMQQoEjxL+4SEikCKGjS5i8nh5DEEKBI8S/uEhIpAijo0mYvJ4eQxBDw9wGyV/iHDs33nQAAAABJRU5ErkJggg==" alt="Card Chip">
      </div>
    </div>

    <!-- Back -->
    <div class="absolute inset-0 p-2 flex flex-col justify-between rounded-2xl [transform:rotateY(180deg)] [backface-visibility:hidden]" [style]="cardStyle()">
        <div class="w-full h-16 bg-black/80 mt-6"></div>
        <div class="px-6 pb-6">
            <p class="text-xs opacity-70 text-right">CVV</p>
            <div class="h-10 w-full bg-white rounded-md mt-1 flex items-center justify-end px-4 text-black font-mono tracking-widest">
                <span>{{ cvv() }}</span>
            </div>
        </div>
    </div>
  </div>
</div>
